module.exports = __webpack_public_path__ + "img/592.db04593f.jpg";